import { render, staticRenderFns } from "./MissionDetailImage.vue?vue&type=template&id=24670bd2"
import script from "./MissionDetailImage.vue?vue&type=script&lang=ts"
export * from "./MissionDetailImage.vue?vue&type=script&lang=ts"
import style0 from "./MissionDetailImage.vue?vue&type=style&index=0&id=24670bd2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports